import {Component, ViewChild} from '@angular/core';
import {ReplaySubject} from 'rxjs';
import {NgForm} from '@angular/forms';
import {StepScreenModel} from '../../../../shared/step/step-screen.component';
import {FormErrors} from '../../../../../components/forms/validation/form-validator.class';
import {PremedicalEducationScreensManager} from '../premedical-education-screens-manager.service';
import {MedicalEducation} from '../../../../../domain/model/education/medical/medical-education.model';
import {MedicalEducationService} from '../../../../../domain/model/education/medical/medical-education.service';
import {CompletedInUSAProjection} from '../../../../../domain/model/education/medical/medical-education.projections';

@Component({
    template: require('./completed-medical-school-in-usa-screen.component.html'),
    styles: [require('./completed-medical-school-in-usa-screen.component.scss')]
})
export class CompletedMedicalSchoolInUsaScreenComponent {

    constructor(readonly educationService: MedicalEducationService, readonly screensManager: PremedicalEducationScreensManager) {
    }

    // region Form
    readonly form$ = new ReplaySubject<NgForm>(1);

    @ViewChild(NgForm) set form(value: NgForm) {
        this.form$.next(value);
    }

    // endregion

    stepScreenModel = new StepScreenModel<MedicalEducation>({
        initialDataModel: new MedicalEducation(),
        specificValidationMessages: {},
        screensManager: this.screensManager,
        _loadDataFn: () => {
            return this.educationService.getCurrentUserModel(CompletedInUSAProjection);
        },
        _submitDataFn: (model: MedicalEducation) => {
            return this.educationService.updateCurrentUserModel(model);
        }
    });

    get model(): MedicalEducation {
        return this.stepScreenModel.dataModel;
    }

    get formErrors(): FormErrors {
        return this.stepScreenModel.formErrors;
    }

    handleValueChange() {
        this.stepScreenModel.goToNextScreen();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/education/steps/premedical/question/completed-medical-school-in-usa-screen.component.ts